var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('RouterLink',{attrs:{"to":_vm.aLink}},[_c('img',{style:({'height':_vm.cardHeight+'px'}),attrs:{"src":_vm.imgUrl,"alt":_vm.label}}),_c('span',[_vm._v(_vm._s(_vm.label))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }